import React from "react"
import { Card } from "react-bootstrap"

import { ProductConfiguratorMode } from "shared/types/ProductConfiguratorMode"
import {
  ProductConfiguratorModeSelect,
  ProductConfiguratorModeSelectProps
} from "shared/ui/product-configurator-mode-select/ProductConfiguratorModeSelect"

import {
  ProductConfigurator,
  ProductConfiguratorModel
} from "widgets/product-configurator/ProductConfigurator"
import { ProductConfiguratorContextProvider } from "widgets/product-configurator/model/ProductConfiguratorContext"

import "../styles/_product-configuration-page.scss"

export interface ProductConfigurationPageViewModel {
  productConfiguratorModel: ProductConfiguratorModel
  productConfiguratorModeSelectModel: ProductConfiguratorModeSelectProps
  productConfiguratorMode: ProductConfiguratorMode | undefined
}

export const ProductConfigurationPageView = React.memo(
  ({
    productConfiguratorModel,
    productConfiguratorModeSelectModel,
    productConfiguratorMode
  }: ProductConfigurationPageViewModel) => {
    if (!productConfiguratorMode) {
      return (
        <div className="product-configuration-page">
          <Card className="product-configuration-page__mode-select-card">
            <Card.Body>
              <ProductConfiguratorModeSelect
                {...productConfiguratorModeSelectModel}
              />
            </Card.Body>
          </Card>
        </div>
      )
    }

    return (
      <div className="product-configuration-page">
        <ProductConfiguratorContextProvider model={productConfiguratorModel}>
          <ProductConfigurator
            {...productConfiguratorModel}
            hideTitle
            mode={ProductConfiguratorMode.CONFIGURATION}
          />
        </ProductConfiguratorContextProvider>
      </div>
    )
  }
)
